var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "role"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "col-md-12 mb-2"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('b', [_vm._v("Bulk Upload for Accepted/Rejected Disputes")])]), _vm._v(" "), _c('div', {
    staticClass: "card-body1"
  }, [_c('form', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('b-input-group', {
    staticClass: "col-md-8"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Upload File:",
      "description": "Allowed file types: .CSV",
      "label-cols": 3
    }
  }, [_c('input', {
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _vm._v(" "), _c('b-button', {
    staticClass: "btn btn-sm btn-info",
    on: {
      "click": _vm.uploadFile
    }
  }, [_vm._v("Upload")])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n                  Download sample CSV file for upload\n                   "), _c('i', {
    staticClass: "fa fa-download downloadIcon",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Download csv format"
    },
    on: {
      "click": function($event) {
        _vm.downloadSampleCsv()
      }
    }
  })])]), _vm._v(" "), (_vm.bulkDisputeCSVDataFlag) ? _c('div', {
    staticClass: "col-12"
  }, [_c('p', {
    staticClass: "counts"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(" Failed: " + _vm._s(_vm.FailedRecords) + " ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("\n                  Success: " + _vm._s(_vm.successData) + " ")]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "active": _vm.show2,
      "duration": "0.6",
      "spinner": "bar-fade-scale",
      "color": "#000080"
    }
  })], 1), _c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Shipping ID")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("DisputeAmount")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("DisputeReason")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("DisputeSubReason")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Comments")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("UnboxingVideo")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("PhotoProof-1")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("PhotoProof-2")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("PhotoProof-3")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("PhotoProof-4")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("OtherProof-1")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("OtherProof-2")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("DisputeStatus")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("DisputeTeamComment")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("fromHistoryTable")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("FailureReason")])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.bulkDisputeCSVData), function(data) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(data.ShippingID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.DisputeAmount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.DisputeReason))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.DisputeSubReason))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.Comments))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": "data.UnboxingVideo"
      }
    }, [_vm._v(" Tetst-Photo-link ")])]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": "data.PhotoProof.1"
      }
    }, [_vm._v(" Tetst-Photo-link ")])]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": "data.PhotoProof.2"
      }
    }, [_vm._v(" Tetst-Photo-link ")])]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": "data.PhotoProof.3"
      }
    }, [_vm._v(" Tetst-Photo-link ")])]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": "data.PhotoProof.4"
      }
    }, [_vm._v(" Tetst-Photo-link ")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.OtherProof - 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.OtherProof - 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.DisputeStatus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.DisputeTeamComment))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.fromHistoryTable))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.FailureReason))])])
  }))])]), _c('br')], 1)]) : _vm._e()])])]), _vm._v(" "), _c('b-card', [_c('div', {
    slot: "header"
  }, [_c('b', [_vm._v("Reason and Sub-Reason list")])]), _vm._v(" "), _c('div', {
    staticClass: "card-body1"
  }, [_c('form', [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.rtoReasonSub.length > 0) ? _c('div', {
    attrs: {
      "id": "RTO"
    }
  }, [_c('b', [_vm._v("RTO:")]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Reason")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "colspan": "12"
    }
  }, [_c('b', [_vm._v("Sub-Reason")])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.rtoReasonSub), function(data) {
    return _c('tr', [_c('td', {
      attrs: {
        "width": "25%"
      }
    }, [_vm._v(_vm._s(data.reason))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "75%"
      }
    }, [_vm._v(_vm._s(data.subreason))])])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.dtoReasonSub.length > 0) ? _c('div', {
    attrs: {
      "id": "DTO"
    }
  }, [_c('b', [_vm._v("DTO:")]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Reason")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "colspan": "12"
    }
  }, [_c('b', [_vm._v("Sub-Reason")])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.dtoReasonSub), function(data) {
    return _c('tr', [_c('td', {
      attrs: {
        "width": "25%"
      }
    }, [_vm._v(_vm._s(data.reason))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "75%"
      }
    }, [_vm._v(_vm._s(data.subreason))])])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.dtoDisputeReasonSub.length > 0) ? _c('div', {
    attrs: {
      "id": "DTODispute"
    }
  }, [_c('b', [_vm._v("DTODispute:")]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Reason")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "colspan": "12"
    }
  }, [_c('b', [_vm._v("SubReason")])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.dtoDisputeReasonSub), function(data) {
    return _c('tr', [_c('td', {
      attrs: {
        "width": "25%"
      }
    }, [_vm._v(_vm._s(data.reason))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "75%"
      }
    }, [_vm._v(_vm._s(data.subreason))])])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.forwardDispReasonSub.length > 0) ? _c('div', {
    attrs: {
      "id": "ForwardDispute"
    }
  }, [_c('b', [_vm._v("ForwardDispute:")]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Reason")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "colspan": "12"
    }
  }, [_c('b', [_vm._v("SubReason")])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.forwardDispReasonSub), function(data) {
    return _c('tr', [_c('td', {
      attrs: {
        "width": "25%"
      }
    }, [_vm._v(_vm._s(data.reason))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "75%"
      }
    }, [_vm._v(_vm._s(data.subreason))])])
  }))])]) : _vm._e()])])])])], 1)]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "active": _vm.show,
      "duration": "0.6",
      "spinner": "bar-fade-scale",
      "color": "#FF6700"
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9ad52b84","hasScoped":true}!./src/views/components/DisputeAcceptRejectUpload/DisputeAcceptRejectUpload.component.html
// module id = 639
// module chunks = 1